module.exports = __webpack_public_path__ + "static/img/privacy-1-2.411a260.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-1-2.png
// module id = zQuZ
// module chunks = 1